import styled from 'styled-components';

export const ContainerProduct = styled.div`
  margin: 20px 0px 40px 40px;

  table {
    margin-top: 20px;
  }

  td {
    height: 30px;
  }

  .filter {
    display: flex;
  }

  h2 {
    margin-bottom: 40px;
  }

  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
  }
`;
